var map = {
	"./accordion-arrow.svg": 715,
	"./arrow.svg": 716,
	"./bigcommerce-logo.svg": 717,
	"./magento1-logo.svg": 718,
	"./magento2-logo.svg": 719,
	"./opencart-logo.svg": 720,
	"./prestashop-logo.svg": 721,
	"./shopify-logo.svg": 722,
	"./shopware-logo.svg": 723,
	"./trustpilot-logo.svg": 724,
	"./woocommerce-logo.svg": 725
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 714;


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images ^\.\/.*\.svg$
// module id = 714
// module chunks = 0